import { Lap } from "../models/IRider";

class LapsHelper {
    getBestLap(laps?: Lap[]): Lap | undefined {
        if (laps === undefined || laps.length === 0) {
            return undefined;
        }
        let lap = laps[0];
        laps.forEach((l: Lap) => {
            if (l.timeMs < lap.timeMs) {
                lap = l;
            }
        });
        return lap;
    }

    getBestTime(laps?: Lap[], idBestLap?: number): number {
        if (laps === undefined || laps.length === 0 || idBestLap === undefined || idBestLap < 1) {
            return 10000000;
        }
        return laps[idBestLap - 1].timeMs;
    }

    filterBreakLaps(laps?: Lap[], eventBest?: number): Lap[] {
        const twiceBestLap = eventBest ? eventBest * 2 : 10000000;
        if (laps === undefined || laps.length === 0) {
            return [];
        }
        return laps.filter((l: Lap) => l.timeMs < twiceBestLap);
    }


}

const LapsHelperInstance = new LapsHelper();

export default LapsHelperInstance;